
export class ConfigDto {
	inicial: string;
	asunto: string;
	saludo: string;
	cuerpo: string;
	despedida: boolean;
	firma: boolean;
}
